import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Badge, Space } from 'udesk-ui';

const Template = (props) => {
    const { item } = props;

    const locales = UdeskLocales['current'];

    const color =
        item['f_2'] === Udesk.enums.appealCheckStatus.readed.name
            ? '#1A6EFF'
            : item['f_2'] === Udesk.enums.appealCheckStatus.inComplaint.name
            ? '#F09A00'
            : item['f_2'] === Udesk.enums.appealCheckStatus.reviewed.name
            ? '#0FBA26'
            : 'rgba(0, 0, 0, 0.25)';

    return (
        <div className="appeal-checking-task-page-list-item" title={item['f_61']}>
            <div className="appeal-checking-task-page-list-item-row has-margin">
                <div className="appeal-checking-task-page-list-item-row-left">{item['f_61']}</div>
                <div className="appeal-checking-task-page-list-item-row-right">
                    <Space size={0}>
                        <Badge color={color} />
                        <div>{item['f_2']}</div>
                    </Space>
                </div>
            </div>
            <div className="appeal-checking-task-page-list-item-row">
                <div
                    className="appeal-checking-task-page-list-item-row-left"
                    style={{ color: '#1A6EFF' }}
                >
                    {item['f_1']}
                </div>
                <div
                    className="appeal-checking-task-page-list-item-row-right"
                    style={{
                        color:
                            item['f_62'] === Udesk.enums.isManual.yes.id
                                ? '#0FBA26'
                                : 'rgba(0, 0, 0, 0.25)',
                    }}
                >
                    {Udesk.enums.isManual.getName(item['f_62'])}
                </div>
            </div>
            <div className="appeal-checking-task-page-list-item-row">
                <div className="appeal-checking-task-page-list-item-row-left">
                    <Space>
                        <div>
                            {/* 评级: */}
                            {locales.pages.appealCheckingTask.sdk.index.grade}
                        </div>
                        <div style={{ color: '#11A848' }}>{item['f_6']}</div>
                    </Space>
                </div>
            </div>
        </div>
    );
};

export default Template;
